import { guideSteps } from "../data";
import SectionHeader from "./SectionHeader";

export default function Guide() {
  return (
    <section id="guide" className="scroll-mt-20 bg-background-100/60">
      <div className="site-container py-12 md:py-16">
        <SectionHeader
          eyebrow="避雷指南 · 防塌手册"
          eyebrowIcon="ri-road-map-line"
          title="四步行动路径，把风险挡在门外"
          desc="避雷不是让你疑神疑鬼，而是建立一套顺手、可复用的判断流程。照着下面四步走，遇到任何争议都能保持自己的节奏。"
        />

        <ol className="relative space-y-6">
          <span className="absolute left-5 top-4 bottom-4 w-px bg-background-300 hidden md:block" aria-hidden="true"></span>
          {guideSteps.map((s) => (
            <li
              key={s.step}
              className="relative flex flex-col md:flex-row gap-4 md:gap-8 rounded-lg border border-background-200 bg-background-50 p-5 md:p-6"
            >
              <div className="flex md:flex-col md:items-center gap-4 shrink-0">
                <span className="flex items-center justify-center w-11 h-11 rounded-lg bg-foreground-950 text-accent-400 font-serif text-lg font-bold">
                  {s.step}
                </span>
              </div>

              <div className="flex-1">
                <h3 className="text-lg font-bold text-foreground-950">{s.title}</h3>
                <p className="mt-2 text-sm md:text-[15px] leading-relaxed text-foreground-600">{s.desc}</p>
                <ul className="mt-3 flex flex-wrap gap-2">
                  {s.points.map((p) => (
                    <li
                      key={p}
                      className="inline-flex items-center gap-1.5 rounded-full bg-secondary-100 px-3 py-1.5 text-xs font-medium text-secondary-900 whitespace-nowrap"
                    >
                      <i className="ri-check-double-line text-xs w-3 h-3 flex items-center justify-center text-secondary-600" aria-hidden="true"></i>
                      {p}
                    </li>
                  ))}
                </ul>
              </div>
            </li>
          ))}
        </ol>
      </div>
    </section>
  );
}